<div class="faqs-page">
  <!-- Hero Section -->
  <div class="faq-hero-section">
    <div class="container px-4">
      <div class="text-center text-white">
        <div class="hero-icon mb-4">
          <i class="fa-solid fa-book-open"></i>
        </div>
        <h1 class="hero-title mb-4">Guides & Resources</h1>
        <p class="hero-description mb-5">
          Explore step-by-step guides and best practices to get the most out of our platform.
          Search topics or browse categories to find the help you need.
        </p>
        <div class="hero-stats d-flex align-items-center justify-content-center gap-4 flex-wrap">
          <div class="stat-badge">
            <i class="fa-solid fa-book"></i>
            <span>80+ Guides</span>
          </div>
          <div class="stat-badge">
            <i class="fa-solid fa-users"></i>
            <span>Community Ready</span>
          </div>
          <div class="stat-badge">
            <i class="fa-solid fa-clock"></i>
            <span>Always Updated</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search Section -->
  <div class="faq-search-section">
    <div class="container px-4">
      <div class="search-wrapper position-relative">
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearch()"
          (keyup.enter)="onSearch()"
          placeholder="Search guides..."
          class="search-input w-100"
        />
        <button
          *ngIf="searchQuery"
          class="search-clear-button"
          (click)="clearSearch()"
          type="button"
        >
          <i class="fa-solid fa-times"></i>
        </button>
        <button class="search-button" (click)="onSearch()" type="button">
          <i class="fa-solid fa-search"></i>
        </button>
      </div>
      <div class="popular-searches mt-4 d-flex flex-wrap gap-2 justify-content-center">
        <span class="text-muted fw-medium">Popular topics:</span>
        <button
          class="popular-tag"
          (click)="onCategoryClick('Getting Started')"
          [class.active]="selectedCategory === 'Getting Started'"
        >
          Getting Started
        </button>
        <button
          class="popular-tag"
          (click)="onCategoryClick('Setup')"
          [class.active]="selectedCategory === 'Setup'"
        >
          Setup
        </button>
        <button
          class="popular-tag"
          (click)="onCategoryClick('Billing')"
          [class.active]="selectedCategory === 'Billing'"
        >
          Billing
        </button>
        <button
          class="popular-tag"
          (click)="onCategoryClick('Security')"
          [class.active]="selectedCategory === 'Security'"
        >
          Security
        </button>
        <button
          class="popular-tag"
          (click)="onCategoryClick('Integration')"
          [class.active]="selectedCategory === 'Integration'"
        >
          Integration
        </button>
      </div>
    </div>
  </div>

  <!-- Categories Section -->
  <div class="faq-categories-section py-5">
    <div class="container px-4">
      <div class="text-center mb-5">
        <h2 class="section-title mb-3">Browse by Category</h2>
        <p class="section-subtitle">Select a category to view related guides</p>
      </div>
      <div class="row g-4">
        <div class="col-md-6 col-lg-3">
          <div class="category-card">
            <div class="category-icon">
              <i class="fa-solid fa-rocket"></i>
            </div>
            <h3 class="category-title">Getting Started</h3>
            <p class="category-description">Everything you need to begin</p>
            <div class="category-footer">
              <span>18 guides</span>
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3">
          <div class="category-card">
            <div class="category-icon">
              <i class="fa-solid fa-credit-card"></i>
            </div>
            <h3 class="category-title">Billing & Payments</h3>
            <p class="category-description">Manage your subscriptions</p>
            <div class="category-footer">
              <span>12 guides</span>
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3">
          <div class="category-card">
            <div class="category-icon">
              <i class="fa-solid fa-shield-halved"></i>
            </div>
            <h3 class="category-title">Security & Privacy</h3>
            <p class="category-description">Keep your data safe</p>
            <div class="category-footer">
              <span>10 guides</span>
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3">
          <div class="category-card">
            <div class="category-icon">
              <i class="fa-solid fa-puzzle-piece"></i>
            </div>
            <h3 class="category-title">Integrations</h3>
            <p class="category-description">Connect your tools</p>
            <div class="category-footer">
              <span>14 guides</span>
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Guides Content -->
  <div *ngIf="!loading">
    <div *ngIf="filteredGuides.length === 0" class="text-center py-5">
      <p class="text-muted">No guides found matching your search.</p>
    </div>

    <div *ngFor="let group of filteredGuides" class="faq-group-section py-5">
      <div class="container px-4">
        <div class="mb-4">
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="section-icon">
              <i class="fa-solid fa-circle-info"></i>
            </div>
            <h2 class="section-title mb-0">{{ group.grouptitle }}</h2>
          </div>
          <p class="section-subtitle mb-0">
            Detailed guides and how-tos for this category
          </p>
        </div>

        <div class="faqs-list">
          <div
            *ngFor="let guide of group.guideLines; let i = index"
            class="faq-item mb-3"
            [class.expanded]="isGuideExpanded(getGuideId(group.id, i))"
          >
            <button
              class="faq-toggle w-100 d-flex justify-content-between align-items-center text-start"
              (click)="toggleGuide(getGuideId(group.id, i))"
            >
              <div class="flex-grow-1 pe-4">
                <h3 class="faq-question mb-2">{{ guide.title }}</h3>
              </div>
              <div class="faq-icon">
                <i
                  class="fa-solid"
                  [ngClass]="isGuideExpanded(getGuideId(group.id, i)) ? 'fa-minus' : 'fa-plus'"
                ></i>
              </div>
            </button>
            <div
              class="faq-content"
              [class.show]="isGuideExpanded(getGuideId(group.id, i))"
            >
              <div class="faq-content-inner">
                <div [innerHTML]="guide.response"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="loading" class="text-center py-5">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-- CTA Section -->
  <div class="faq-cta-section py-5">
    <div class="container px-4">
      <div class="cta-content text-center">
        <i class="fa-solid fa-book-open cta-icon mb-4"></i>
        <h2 class="cta-title mb-3">Need More Help?</h2>
        <p class="cta-description mb-4">
          Our support team is here to help. Get in touch and we'll respond as
          quickly as possible.
        </p>
        <div class="d-flex flex-wrap gap-3 justify-content-center">
          <button class="cta-button-primary">
            <i class="fa-solid fa-comments"></i>
            <span>Start Live Chat</span>
          </button>
          <button class="cta-button-secondary">
            <i class="fa-solid fa-envelope"></i>
            <span>Send Email</span>
          </button>
        </div>
        <div class="cta-features mt-4 d-flex align-items-center justify-content-center gap-4 flex-wrap">
          <div class="d-flex align-items-center gap-2">
            <i class="fa-solid fa-clock"></i>
            <span>24/7 Support</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <i class="fa-solid fa-bolt"></i>
            <span>Fast Response</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <i class="fa-solid fa-heart"></i>
            <span>Expert Team</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
